import React from 'react';

/**
 * Catches render-time errors anywhere in the tree so a single bad render never
 * leaves the user staring at a blank white page. Shows a friendly message with
 * a reload action instead.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Dapp render error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
        <div className="max-w-md w-full rounded-2xl bg-white p-8 text-center shadow-xl">
          <h2 className="mb-2 text-xl font-bold text-gray-900">Something went wrong</h2>
          <p className="mb-6 text-sm text-gray-600">
            The page hit an unexpected error. Reloading usually fixes it. If it
            keeps happening, make sure your wallet is unlocked and on Base.
          </p>
          <button
            onClick={this.handleReload}
            className="rounded-lg bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-2.5 font-semibold text-white shadow-md transition-all hover:from-blue-700 hover:to-purple-700"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
